import { MutationFn, UseQueryFn } from 'shared-ui';

import {
  LicenseResponse,
  LicenseStatusResponse,
  SaveLicenseRequest,
  SaveLicenseResponse,
  ValidateLicenseResponse,
} from './license.types';

export const getLicense: UseQueryFn<void, LicenseResponse | null> = () => {
  return {
    endpoint: '/license',
  };
};

export const getLicenseStatus: UseQueryFn<void, LicenseStatusResponse> = () => {
  return {
    endpoint: '/license/status',
  };
};

export const validateLicense: MutationFn<{ file: Blob }, ValidateLicenseResponse> = ({ file }) => {
  const formData = new FormData();
  formData.append('file', file);

  return {
    endpoint: '/license/validate',
    method: 'POST',
    body: formData,
    file: true,
  };
};

export const saveLicense: MutationFn<SaveLicenseRequest, SaveLicenseResponse> = (body) => {
  return {
    endpoint: '/license',
    method: 'POST',
    body,
  };
};
